import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { searchProduct } from "../../store/actions/product";
// import { css } from "aphrodite-jss";
import { Link } from "react-router-dom";
import style from "../../thema/style";
import { PUBLIC_URL } from "../../config";
import Cart from "./Cart";
import Navigation from "./Navigation";
import { Helmet } from "react-helmet";
import Loading from "./Loading";
import { withRouter } from "react-router-dom";
import _ from "lodash";
// TODO: stokda yoksa sepete ekleyeme!

class Search extends Component {
  constructor(props) {
    super(props);
    this.searchBoxRef = React.createRef();
    this.searchBoxListRef = React.createRef();
    this.editableDiv = React.createRef();
    this.state = {
      query: "",
    };
    this.debouncedSearchProduct = _.debounce(this.props.searchProduct, 500);
  }

  render() {
    return (
      <React.Fragment>
        <div className="search-box" ref={this.searchBoxRef}>
          <input
            type="text"
            className="search-input"
            onChange={(e) => {
              this.setState({ query: e.target.value });
              this.debouncedSearchProduct(e.target.value);
            }}
            placeholder="Aradığınız ürünü yazınız."
            value={this.state.query}
          />
          <div className="search-button">
            <div
              onClick={() => {
                console.log(">>>", this.props.product.searchProductsFetching);
                this.setState({ query: "" });
              }}
            >
              {this.state.query !== "" ? (
                <FontAwesomeIcon icon={["fas", "times"]} color="#666" />
              ) : (
                <FontAwesomeIcon icon={["fas", "search"]} color="#7fb401" />
              )}
            </div>
          </div>
        </div>

        {this.state.query !== "" ? (
          <div className="search-products-box" ref={this.searchBoxListRef}>
            {(this.props.product.searchProductsFetching ||
              this.props.product.searchProducts === null) && (
              <div className="text-center">
                <Loading text={"Yükleniyor"} fontSize={15} />
              </div>
            )}

            {this.props.product.searchProducts &&
              this.props.product.searchProducts.length === 0 && (
                <div className="text-center">
                  <p>
                    "
                    <span style={{ fontWeight: "bold", fontStyle: "italic" }}>
                      {this.state.query}
                    </span>
                    " ile ilgili bir ürün bulunamadı. <br />
                  </p>
                  <p>
                    Aradığınız; "
                    <span style={{ fontWeight: "bold", fontStyle: "italic" }}>
                      {this.state.query}
                    </span>
                    " ürününü diğer satış platformlarımızdan bulabilirsiniz.
                  </p>
                  <hr />
                  <p>
                    <a
                      className="seach-marketplace-link"
                      target="_blank"
                      href={`https://www.trendyol.com/sr?q=${encodeURIComponent(
                        this.state.query
                      )}&qt=${encodeURIComponent(
                        this.state.query
                      )}&st=${encodeURIComponent(
                        this.state.query
                      )}&mid=116238&os=1`}
                    >
                      Trendyol'da "
                      <span style={{ fontWeight: "bold", fontStyle: "italic" }}>
                        {this.state.query}
                      </span>
                      " ürününü bul.
                    </a>
                  </p>
                  <p>
                    <a
                      className="seach-marketplace-link"
                      target="_blank"
                      href={`https://www.hepsiburada.com/magaza/botaniksan?q=${encodeURIComponent(
                        this.state.query
                      )}`}
                    >
                      Hepsiburada'da "
                      <span style={{ fontWeight: "bold", fontStyle: "italic" }}>
                        {this.state.query}
                      </span>
                      " ürününü bul.
                    </a>
                  </p>
                  <p>
                    <a
                      className="seach-marketplace-link"
                      target="_blank"
                      href={`https://www.amazon.com.tr/s?k=${encodeURIComponent(
                        this.state.query
                      )}&me=A6A1JTQ1R9EMG&__mk_tr_TR=%C3%85M%C3%85%C5%BD%C3%95%C3%91&ref=nb_sb_noss`}
                    >
                      Amazon'da "
                      <span style={{ fontWeight: "bold", fontStyle: "italic" }}>
                        {this.state.query}
                      </span>
                      " ürününü bul.
                    </a>
                  </p>
                </div>
              )}

            {this.props.product.searchProducts &&
              this.props.product.searchProducts.map((item, index) => {
                return (
                  <div className="search-box-product-list">
                    <div>
                      <Link
                        to={{
                          pathname: `/urun/${item.slug}`,
                          state: { product: item },
                        }}
                        onClick={() => {
                          this.setState({ query: "" });
                        }}
                      >
                        <img
                          alt={item.name}
                          key={index}
                          src={PUBLIC_URL(item.image)}
                        />
                      </Link>
                    </div>
                    <div style={{ padding: 10, width: "calc(100% - 100px)" }}>
                      <div className="search-box-product-list-title">
                        <Link
                          to={{
                            pathname: `/urun/${item.slug}`,
                            state: { product: item },
                          }}
                          onClick={() => {
                            this.setState({ query: "" });
                          }}
                        >
                          {item.name}
                        </Link>
                      </div>
                      <div>
                        {item.categories.map((category) => {
                          return (
                            <Link
                              to={{
                                pathname: `/kategori/${category.slug}`,
                                state: { category: category },
                              }}
                              onClick={() => {
                                this.setState({ query: "" });
                              }}
                            >
                              <div className="search-box-product-list-category">
                                {category.title}
                              </div>
                            </Link>
                          );
                        })}
                      </div>
                    </div>

                    {/* <AddCartButton img={null} product={item} /> */}
                  </div>
                );
              })}
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  router,
  customer,
  setting,
  page,
  category,
  product,
}) => {
  return {
    router,
    customer,
    setting,
    page,
    category,
    product,
  };
};

const mapDispatchToProps = { searchProduct };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search));



// WEBPACK FOOTER //
// ./src/components/shared/Search.js